var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "dynamic-form-editor"
  }, [_c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.editorTitle) + " ")]), _c('section', {
    staticClass: "dynamic-form-editor__subjects"
  }, [_c('VueDraggable', {
    attrs: {
      "handle": ".subject-layout-drag-handler",
      "list": _vm.vModelForPages,
      "disabled": _vm.isReadOnly
    },
    on: {
      "end": _vm.handleSortingPages
    }
  }, _vm._l(_vm.vModelForPages, function (page, index) {
    return _c('b-card', {
      key: "".concat(_vm.vModelForPages[index]._id, "_").concat(_vm.rerenderingCount),
      staticClass: "mt-3"
    }, [_c('SubjectLayout', {
      ref: 'subjectLayoutRef+' + _vm.vModelForPages[index]._id,
      refInFor: true,
      attrs: {
        "index": index,
        "title": _vm.vModelForPages[index].title,
        "move-up-is-disabled": index == 0,
        "move-down-is-disabled": index == _vm.vModelForPages.length - 1,
        "expanded": _vm.expandedStateForSubjects[_vm.vModelForPages[index]._id],
        "readonly": _vm.isReadOnly,
        "visible-conditions": _vm.vModelForPages[index].visible_when_any,
        "field-options-for-visible-conditions": _vm.sanitizedFields
      },
      on: {
        "update:title": function updateTitle($event) {
          return _vm.$set(_vm.vModelForPages[index], "title", $event);
        },
        "update:expanded": function updateExpanded($event) {
          return _vm.$set(_vm.expandedStateForSubjects, _vm.vModelForPages[index]._id, $event);
        },
        "update:visibleConditions": function updateVisibleConditions($event) {
          return _vm.$set(_vm.vModelForPages[index], "visible_when_any", $event);
        },
        "update:visible-conditions": function updateVisibleConditions($event) {
          return _vm.$set(_vm.vModelForPages[index], "visible_when_any", $event);
        },
        "top": function top($event) {
          return _vm.moveToTop(index);
        },
        "up": function up($event) {
          return _vm.moveUp(index);
        },
        "down": function down($event) {
          return _vm.moveDown(index);
        },
        "bottom": function bottom($event) {
          return _vm.moveToBottom(index);
        },
        "remove": function remove($event) {
          return _vm.removePage(index);
        }
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function fn() {
          return [_c('p', [_vm._v("分區設定：")]), _c('div', {
            staticClass: "mt-3"
          }, [_c('VueDraggable', {
            attrs: {
              "handle": ".option-drag-handler",
              "list": _vm.sectionsOfPage(page),
              "disabled": _vm.isReadOnly
            },
            on: {
              "end": function end(e) {
                return _vm.handleSortingSections(e, page);
              }
            }
          }, [_vm._l(_vm.sectionsOfPage(page), function (option, optionIndex) {
            return _c('div', {
              key: index + '-opt-' + optionIndex,
              staticClass: "mb-3"
            }, [_c('div', {
              staticClass: "d-flex align-items-center"
            }, [_c('div', {
              staticClass: "flex-grow-1 flex-shrink-1 d-flex align-items-center section-input"
            }, [_c('i', {
              staticClass: "fa fa-bars mr-3 option-drag-handler"
            }), _c('b-form-input', {
              ref: "section_name_".concat(page._id, "_").concat(optionIndex),
              refInFor: true,
              attrs: {
                "placeholder": "請輸入選項",
                "disabled": _vm.isReadOnly
              },
              model: {
                value: option.title,
                callback: function callback($$v) {
                  _vm.$set(option, "title", $$v);
                },
                expression: "option.title"
              }
            })], 1), !_vm.isReadOnly ? _c('div', {
              staticClass: "d-flex flex-grow-1 flex-shrink-0 align-items-center"
            }, [_c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center text-nowrap",
              attrs: {
                "variant": "inverse-success"
              },
              on: {
                "click": function click($event) {
                  return _vm.createSection(page, optionIndex);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-plus"
            }), _vm._v(" 增加 ")]), _c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center text-nowrap",
              attrs: {
                "variant": "inverse-danger"
              },
              on: {
                "click": function click($event) {
                  return _vm.removeSection(option);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-18px mdi-playlist-remove"
            }), _vm._v(" 移除 ")]), _c('b-button', {
              staticClass: "ml-2 p-1 d-inline-flex align-items-center text-nowrap",
              attrs: {
                "variant": _vm.deepGet(option, 'visible_when_any.length', 0) > 0 ? 'primary' : 'secondary',
                "disabled": _vm.isReadOnly
              },
              on: {
                "click": function click($event) {
                  return _vm.toggleVisibleCondition(option);
                }
              }
            }, [_c('span', {
              staticClass: "mdi mdi-lightbulb-on-outline"
            }), _vm._v(" 觸發顯示 ")])], 1) : _vm._e()]), _vm.deepGet(option, 'visible_when_any.length', 0) > 0 ? _c('VisibleConditionEditor', {
              staticClass: "pt-3 pl-5",
              attrs: {
                "fieldOptionsForVisibleConditions": _vm.sanitizedFields
              },
              model: {
                value: option.visible_when_any,
                callback: function callback($$v) {
                  _vm.$set(option, "visible_when_any", $$v);
                },
                expression: "option.visible_when_any"
              }
            }) : _vm._e()], 1);
          }), _c('b-button', {
            staticClass: "p-1 d-inline-flex align-items-center text-nowrap",
            attrs: {
              "variant": "inverse-success"
            },
            on: {
              "click": function click($event) {
                return _vm.createSection(page);
              }
            }
          }, [_c('span', {
            staticClass: "mdi mdi-18px mdi-playlist-plus"
          }), _vm._v(" 增加分區 ")])], 2)], 1)];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 1)], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "subject-type-menu mt-3"
  }, [_c('span', {
    staticClass: "subject-type-menu__icon mdi mdi-24px mdi-plus"
  }), _c('div', {
    staticClass: "subject-type-menu__button-wrapper"
  }, [_c('b-button', {
    staticClass: "subject-type-menu__create-button",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": _vm.createNewPage
    }
  }, [_c('i', {
    staticClass: "mdi mdi-18px mdi-note-plus-outline"
  }), _vm._v(" 分頁 ")])], 1)]) : _vm._e(), !_vm.isReadOnly ? _c('div', {
    staticClass: "mt-3 d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('cancel');
      }
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.outputSubjects
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }